<template>
  <v-dialog v-model="dialog" max-width="1024px">
    <v-card>
      <v-card-title>
        <span class="text-h5">
          {{ boleto?.payment?.description }}
          <v-chip class="ml-2" :color="paymentStatus" label>
            {{ boleto?.payment?.validity | date }}
          </v-chip>
        </span>
        <v-spacer></v-spacer>
        <v-btn-toggle v-model="paymentMethod" mandatory color="primary">
          <v-btn value="pix" :color="paymentMethod === 'pix' ? 'primary' : undefined">Pix</v-btn>
          <v-btn value="boleto" :color="paymentMethod === 'boleto' ? 'primary' : undefined">Boleto</v-btn>
        </v-btn-toggle>
      </v-card-title>
      <v-card-text>
        <iframe v-if="paymentMethod === 'boleto'" :src="`data:application/pdf;base64,${boleto?.pdf}`"></iframe>
        <div v-else class="d-flex justify-center flex-column flex-md-row gap-4 align-center">
          <v-card outlined color="white" style="width: 400px; height: 400px">
            <v-img
              :src="`https://quickchart.io/qr?text=${boleto?.pix?.pixCopiaECola}&size=400&ecLevel=L`"
              height="400"
              width="400"
            >
              <template v-slot:placeholder>
                <div class="d-flex justify-center align-center fill-height">
                  <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
                </div>
              </template>
            </v-img>
          </v-card>
          <v-card>
            <v-card-text>
              <h6 class="text-h6">Valor: {{ boleto.payment.value | currency }}</h6>
              <p>Vencimento: {{ boleto.payment.validity | date }}</p>
              <v-divider class="my-2"></v-divider>
              <p class="text-h6">Instruções para o pagamento</p>
              <p>1. Abra o aplicativo do seu banco</p>
              <p>2. Procure pela opção Pix QR Code</p>
              <p>3. Escaneie o QR Code acima</p>
              <p>5. Confirme os dados e finalize o pagamento</p>
            </v-card-text>
            <v-card-actions>
              <v-btn color="primary" @click="copyCode"> Copiar código Pix Copia e Cola</v-btn>
            </v-card-actions>
          </v-card>
        </div>
      </v-card-text>
      <v-card-actions>
        <v-btn color="blue darken-1" text @click="close"> Fechar </v-btn>
        <v-btn color="primary" @click="sendBoleto" :loading="sending" :disabled="sending || successSend">
          {{ successSend ? 'Enviado com sucesso' : 'Enviar via WhatsApp e Email' }}
        </v-btn>

        <v-spacer></v-spacer>
        <template v-if="paymentMethod === 'boleto'">
          <v-btn color="blue darken-1" text @click="copyCode"> Copiar código de barras </v-btn>
          <v-btn color="blue darken-1" text @click="openNewWindow"> Imprimir boleto </v-btn>
        </template>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import moment from 'moment'
import rentalService from '@/services/rental'

export default {
  data() {
    return {
      dialog: false,
      paymentMethod: 'pix',
      sending: false,
      successSend: false,
      boleto: {
        boleto: {
          link: '',
        },
        payment: {
          description: '',
          validity: '',
        },
      },
    }
  },
  methods: {
    async sendBoleto() {
      try {
        this.sending = true
        const rentalId = this.rental?.id || this.boleto?.payment?.contract?.rentalId
        const response = await rentalService.sendBoleto(rentalId, this.boleto.payment.id)
        this.$toast.fire({
          title: `Boleto enviado com sucesso para ${response.phones.length} telefone${
            response.phones.length !== 1 ? 's' : ''
          } e ${response.emails.length} email${response.emails.length !== 1 ? 's' : ''}`,
          icon: 'success',
          showCloseButton: true,
        })
        this.successSend = true
      } catch (error) {
        console.log(error)
        this.$toast.fire({
          title: 'Erro ao enviar boleto',
          icon: 'error',
        })
      } finally {
        this.sending = false
      }
    },
    copyCode() {
      try {
        var code = this.boleto?.boleto?.linhaDigitavel
        if (this.paymentMethod === 'pix') code = this.boleto?.pix?.pixCopiaECola

        navigator.clipboard.writeText(code)
        this.$toast.fire({
          title: 'Código copiado',
          icon: 'success',
          showCloseButton: true,
        })
      } catch {
        this.$toast.fire({
          title: 'Erro ao copiar código',
          icon: 'error',
        })
      }
    },
    openNewWindow() {
      window.open(`data:application/pdf;base64,${this.boleto?.pdf}`, '_blank')
    },
    open(boleto) {
      this.boleto = boleto
      this.dialog = true
      this.successSend = false
    },
    close() {
      this.dialog = false
      this.boleto = {
        boleto: {
          link: '',
        },
        payment: {
          description: '',
          validity: '',
        },
      }
    },
  },
  computed: {
    paymentStatus() {
      let payment = this.boleto?.payment
      if (!payment?.status) return 'warning'
      if (payment.status == 'Paid') return 'success'
      if (payment.status == 'Canceled') return 'secondary'
      const validity = moment(payment.validity).endOf('day')
      if (payment.status == 'Pending' && moment().isAfter(validity)) return 'error'
      return 'warning'
    },
  },
  filters: {
    date(value) {
      return moment(value).format('DD/MM/YYYY')
    },
  },
  created() {
    this.$root.$on(this.componentName, this.open)
  },
  props: {
    componentName: {
      type: String,
      default: 'show-boleto',
    },
    rental: {
      type: Object,
    },
  },
}
</script>

<style scoped>
iframe {
  border: none;
  width: 100%;
  height: calc(90vh - 200px);
}
</style>
